import request from '@/utils/request'

// 答题纠错

let QuestionCorrectionApi = {

  /*列表*/
  getList(data, errorback) {
    return request._post('/shop/study.question_correction/index', data, errorback);
  },

  /*回复*/
  reply(data, errorback) {
    return request._post('/shop/study.question_correction/reply', data, errorback);
  },

  /*删除*/
  del(data, errorback) {
    return request._post('/shop/study.question_correction/del', data, errorback);
  },

  /*状态*/
  status(data, errorback) {
    return request._post('/shop/study.question_correction/status', data, errorback);
  },
}

export default QuestionCorrectionApi;



// WEBPACK FOOTER //
// ./src/api/study/question_correction.js